// extracted by mini-css-extract-plugin
export default {"Emojify":"bcj_a bik_g"};